export const UPDATE_USER = "updateUser";
export const FETCH_CORPORATIONS = "fetchCorporations";
export const FETCH_COMMUNITIES = "fetchCommunities";
export const FETCH_COMMUNITIES_ALL = "fetchCommunitiesAll";
export const FETCH_COMMUNITIES_MIN = "fetchCommunitiesMin";
export const FETCH_USERS = "fetchUsers";
export const FETCH_USERS_ALL = "fetchUsersAll";
export const FETCH_ORDERS = "fetchPendingOrders";
export const FETCH_SIZES = "fetchSizes";
export const FETCH_DIGITAL_FILES = "fetchDigitalFiles";
export const FETCH_NOTIFICATIONS = "fetchNotifications";
export const FETCH_CART = "fetchCart";
export const FETCH_CART_TAX = "fetchCartTax";
export const FETCH_CURRENT_COMMUNITY = "fetchCurrentCommunity";
export const FETCH_CURRENT_CORPORATION = "fetchCurrentCorporation";
export const FETCH_DISCOUNTS = "fetchDiscounts";
export const UPDATE_COMMUNITY = "updateCommunity";
export const SKIP_MONTH = "skipMonth";
export const FETCH_CURRENT_ORDER = "fetchCurrentOrder";
export const FETCH_PRICES = "fetchPrices";
export const FETCH_STATES = "fetchStates";
